var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bag__app" }, [
    _c(
      "div",
      {
        staticClass: "bag container-sticky",
        attrs: { id: "bag", "data-menu-section-inversion-id": "black" },
      },
      [
        _c("div", { staticClass: "content-sticky screen-section" }, [
          _c("div", { staticClass: "section section_small" }, [
            _c("h2", {
              staticClass: "bag__title",
              domProps: { textContent: _vm._s(_vm.$t("bag.title")) },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "bag__product" }, [
              _c(
                "div",
                {
                  staticClass: "bag__product-menu",
                  class: _vm.activateItem ? "bag__product-menu_active" : "",
                },
                _vm._l(_vm.products, function (productItem, productItemKey) {
                  return _c(
                    "div",
                    {
                      ref: "bagProductItem" + productItem.id,
                      refInFor: true,
                      staticClass: "bag__product-menu-item",
                      class: productItem.isActive
                        ? "bag__product-menu-item_active"
                        : "",
                      attrs: { "data-bag-id": productItem.attrId },
                      on: {
                        click: function ($event) {
                          return _vm.activateItem(productItem)
                        },
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "bag__product-menu-item-img",
                        domProps: {
                          innerHTML: _vm._s(
                            require("../img/bag/projects/" +
                              (productItemKey + 1) +
                              ".svg")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bag__product-menu-item-name",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "bag.products.items[" + productItemKey + "].name"
                            )
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bag__product-menu-item-arrow-wrapper" },
                        [
                          _c("div", {
                            staticClass: "bag__product-menu-item-arrow",
                            domProps: {
                              innerHTML: _vm._s(
                                require("../img/projectArrow.svg")
                              ),
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bag__product-info" },
                _vm._l(_vm.products, function (productItem, productItemKey) {
                  return _c(
                    "div",
                    { staticClass: "bag__product-info-item" },
                    [
                      _c(
                        "collapse-transition",
                        { attrs: { duration: 500, easing: "ease-in-out" } },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: productItem.isActive,
                                  expression: "productItem.isActive",
                                },
                              ],
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "bag__product-info-item-content",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bag__product-info-item-content-left",
                                    },
                                    [
                                      _c("h3", {
                                        staticClass:
                                          "bag__product-info-item-name",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "bag.products.items[" +
                                                productItemKey +
                                                "].name"
                                            )
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "bag__product-info-item-desc",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "bag.products.items[" +
                                                productItemKey +
                                                "].desc"
                                            )
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "bag__product-info-item-link",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "bag.products.items[" +
                                                productItemKey +
                                                "].link"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bag__product-info-item-content-right",
                                    },
                                    [
                                      productItem.hasVideo
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "bag__product-info-item-video-wrapper videobox",
                                              attrs: {
                                                href: _vm.$t(
                                                  "bag.products.items[" +
                                                    productItemKey +
                                                    "].videoLink"
                                                ),
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.assetUrl(
                                                    "../img/bag/projects/" +
                                                      (productItemKey + 1) +
                                                      "Video.png"
                                                  ),
                                                  alt: "",
                                                },
                                              }),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "bag__product-info-item-video-wrapper",
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.assetUrl(
                                                    "../img/bag/projects/" +
                                                      (productItemKey + 1) +
                                                      "Video.png"
                                                  ),
                                                  alt: "",
                                                },
                                              }),
                                            ]
                                          ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bag__list" },
              [
                _c("h3", {
                  staticClass: "bag__list-title",
                  domProps: {
                    textContent: _vm._s(_vm.$t("bag.services.title")),
                  },
                }),
                _vm._v(" "),
                _c("List", {
                  attrs: {
                    "list-translations-key": "bag.services.items",
                    items: this.services,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }